/**
 * Frontend mirror of `server/src/lib/scorecards/status.ts`.
 *
 * Same logic both sides — if the colors flickered between server-
 * computed (on entry list) and client-computed (during an optimistic
 * update), users would lose trust. The two files MUST stay in
 * lockstep; CI doesn't catch a drift directly, but the unit tests
 * here mirror the server tests and any divergence will surface.
 */

export type MetricDirection = 'higher_is_better' | 'lower_is_better';
export type MetricStatus = 'green' | 'yellow' | 'red';

const YELLOW_THRESHOLD = 0.8;

export function metricStatus(value: number, goal: number, direction: MetricDirection): MetricStatus {
  if (direction === 'higher_is_better') {
    if (value >= goal) return 'green';
    if (goal === 0) return 'red';
    if (value >= goal * YELLOW_THRESHOLD) return 'yellow';
    return 'red';
  }
  // lower_is_better
  if (value <= goal) return 'green';
  if (goal === 0) return 'red';
  if (value <= goal / YELLOW_THRESHOLD) return 'yellow';
  return 'red';
}
